
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1440 167","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"d":"M0,1.13686838e-13 L1440,1.13686838e-13 C1200,172.5 720,211.333333 0,116.5 L0,1.13686838e-13 Z","id":"path-1"}})]),_c('g',{attrs:{"id":"List-Practice","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"List-practice","transform":"translate(0.000000, -3481.000000)"}},[_c('g',{attrs:{"id":"About","transform":"translate(0.000000, 2823.000000)"}},[_c('g',{attrs:{"id":"BG","transform":"translate(0.000000, 658.000000)"}},[_c('mask',{attrs:{"id":"mask-2","fill":"white"}},[_c('use',{attrs:{"xlink:href":"#path-1"}})]),_c('use',{attrs:{"id":"Mask","fill":"#F8F8FA","xlink:href":"#path-1"}})])])])])])
          )
        }
      }
    